import { Outlet } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import BottomNavigation from '@/components/feature/BottomNavigation';

const showBottomNavPaths = ['/', '/todo', '/projects', '/finance', '/profile'];

export default function AppLayout() {
  const location = useLocation();

  const showBottomNav = showBottomNavPaths.includes(location.pathname);

  return (
    <div className="min-h-screen bg-background-100">
      <div className="max-w-lg mx-auto bg-background-50 min-h-screen relative shadow-sm lg:max-w-xl">
        <Outlet />
        {showBottomNav && <BottomNavigation />}
      </div>
    </div>
  );
}